import { SafeHtml } from "@angular/platform-browser";
import { BaseDialogActionData, BaseDialogData, ButtonColor, CommonActionKey } from "./base-dialog.model";

export const getBaseDialogData = (title?: string | SafeHtml, actions?: BaseDialogActionData[]): BaseDialogData => {
  const targetActions = actions?.length > 0 ? actions : defaultActions;

  return {
    title,
    actions: targetActions
  }
};

const defaultActions: BaseDialogActionData[] = [
  { label: "OK", buttonColor: ButtonColor.Primary, actionKey: CommonActionKey.Ok, initialFocus: true },
];
